import { gql } from "graphql-tag";

export default gql`
  mutation DeleteLike($likeableId: Int!, $likeableType: String!) {
    likeResult: delete_like(
      likeable_id: $likeableId
      likeable_type: $likeableType
    ) {
      likesCount: likes_count
    }
  }
`;
